import React, { useState } from 'react';
import withRouter from '../Common/withRouter';
import { ConfigProvider, Layout } from 'antd';
import HeaderLayout from './Header';
// import FooterLayout from './Footer';
import SidebarLayout from './SidebarLayout';
import { ThemeProvider, styled } from 'styled-components';
import { themecolor, darkthemecolors } from '../../src/config';
import { useTheme } from '../Common/ThemeContext';
import { useStaffTelemetry } from '../hooks/useStaffTelemetry';

const { Content } = Layout;

// Define the StyleLayout styled component outside the functional component
const StyleLayout = styled(Layout)`
  margin-left: ${themecolor.components.Menu.verticalSidebarWidth}px;
  position: relative;
  padding: calc(${themecolor.token.controlHeight}px * 2) 24px 0;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;

  .ant-breadcrumb { 
    ol {
      justify-content: end;
    }
  }

  @media screen and (max-width: 992px) {
    margin-left: 0 !important;
    padding: calc(${themecolor.token.controlHeight}px * 2) 12px 0;
  }
`;

const LayoutComponents = ({ children }) => {

  const { theme, toggleTheme } = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useStaffTelemetry();

  const handleToggleMode = () => {
    toggleTheme();
  };
  return (
    <React.Fragment>
      <ThemeProvider theme={theme === 'dark' ? darkthemecolors : themecolor}>
        <ConfigProvider theme={theme === 'dark' ? darkthemecolors : themecolor}>
          <SidebarLayout theme={theme} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
          <Layout style={{ minHeight: '100vh' }}>
            <HeaderLayout darkMode={theme} handleToggleMode={handleToggleMode} onToggleDrawer={() => setDrawerOpen(!drawerOpen)} />
            <StyleLayout id='antLayoutContent'>
              <Content>
                {children}
              </Content>
            </StyleLayout>
            {/* <FooterLayout /> */}
          </Layout>
        </ConfigProvider>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default withRouter(LayoutComponents);
